module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "citroen-advisor-fr.eba8f63d.png";